<template>
  <span v-if="averagePrice">
    <template v-if="averagePrice.isFree">
      {{ t('common.free') }}
    </template>
    <template v-else>
      <span class="font-semibold">{{ '$'.repeat(averagePrice.boldCount) }}</span><span class="text-gray-500">{{ '$'.repeat(5 - averagePrice.boldCount) }}</span>
    </template>
  </span>
</template>

<script setup lang="ts">
import type { CampgroundAveragePrice } from '~/types/campground'

defineProps<{
  averagePrice: CampgroundAveragePrice
}>()

const { t } = useI18n()
</script>
